import React from 'react';
import { IconButton } from '@mui/material';
import { Box } from '@mui/system';

import ClearIcon from '@mui/icons-material/Clear';

import { CLEAR_BUTTON_SX, ExpandingBoxInput, ExpandingBoxShell } from './styles';

// Centred over the app bar rather than laid out in it, so opening a box never
// reflows the toolbar behind it.
const OVERLAY_SX = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 2,
  maxWidth: '95vw',
};

/**
 * The wide input the header opens over its toolbar — the shell behind both the
 * search box and the add-URL box.
 */
export default function ExpandingBox({
  inputRef, onCancel, action, ...inputProps
}) {
  return (
    <Box sx={OVERLAY_SX}>
      <ExpandingBoxShell sx={{ position: 'relative', maxWidth: '95vw' }}>
        <ExpandingBoxInput ref={inputRef} autoFocus {...inputProps} />
        <IconButton onClick={onCancel} sx={CLEAR_BUTTON_SX} size="small">
          <ClearIcon fontSize="small" />
        </IconButton>
        {action}
      </ExpandingBoxShell>
    </Box>
  );
}
